import { NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { PasswordModule } from 'primeng/password';
import { DialogComponent } from './components/dialog/dialog.component';
import { PrivacydialogComponent } from './components/privacydialog/privacydialog.component';
import { PageNotFoundComponent } from './components/pagenotfound/pagenotfound.component';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
@NgModule({
  declarations: [
    DialogComponent,
    PrivacydialogComponent,
    PageNotFoundComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    ButtonModule,
    DatePickerModule,
    CheckboxModule,
    ConfirmDialogModule,
    DialogModule,
    SelectModule,
    AccordionModule,
    DynamicDialogModule,
    ToggleSwitchModule,
    InputTextModule,
    MenubarModule,
    MenuModule,
    MultiSelectModule,
    RadioButtonModule,
    RippleModule,
    SelectButtonModule,
    SplitButtonModule,
    TableModule,
    TooltipModule,
    PasswordModule,
    CardModule,
    PanelModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    DatePickerModule,
    CheckboxModule,
    ConfirmDialogModule,
    DialogModule,
    SelectModule,
    DynamicDialogModule,
    ToggleSwitchModule,
    InputTextModule,
    MenubarModule,
    MultiSelectModule,
    RadioButtonModule,
    SelectButtonModule,
    SplitButtonModule,
    TableModule,
    AccordionModule,
    TooltipModule,
    PasswordModule,
    DialogComponent,
    PrivacydialogComponent,
    PageNotFoundComponent,
    CardModule,
    PanelModule,
  ],
  providers: [ConfirmationService, DialogService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
